import { render, staticRenderFns } from "./SCPrice.vue?vue&type=template&id=dcdbce8e"
import script from "./SCPrice.vue?vue&type=script&lang=js"
export * from "./SCPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports